import { associateEntity } from '../../actions/associate-entity.js'
import { disconnectTenant } from '../../actions/disconnect-tenant.js'

let listenersAdded = false
export function addListeners (containerElement, callbacks, browserAppAccount, tokenSetInfo) {
  if (listenersAdded) return
  listenersAdded = true

  console.log('addListeners tenants grid', containerElement)
  containerElement.addEventListener('click', async (clickEvent) => {
    console.log('clickEvent', clickEvent)
    const buttonElement = clickEvent.target.closest('button')
    console.log('buttonElement', buttonElement)
    if (!buttonElement) return

    buttonElement.classList.add('is-loading')

    const buttonAction = buttonElement.getAttribute('data-action')
    console.log('buttonAction', buttonAction)
    if (!buttonAction) return

    await handleButtonAction(buttonAction, buttonElement, callbacks, browserAppAccount, tokenSetInfo)

    buttonElement.classList.remove('is-loading')
  })
}

async function handleButtonAction (buttonAction, buttonElement, callbacks = {}, browserAppAccount, tokenSetInfo) {
  console.log('handleButtonAction', buttonAction)
  if (buttonAction === 'associate') {
    const xeroEntityId = buttonElement.getAttribute('data-xero-id')
    if (!xeroEntityId) return

    await associateEntity(browserAppAccount?.data?.appAccountId, xeroEntityId)

    await callbacks.onAssociated?.()
  }

  if (buttonAction === 'disconnect') {
    const xeroConnectionId = buttonElement.getAttribute('data-connection-id')
    if (!xeroConnectionId) return

    await disconnectTenant(tokenSetInfo.appTokenId, xeroConnectionId)

    await callbacks.onAssociated?.()
  }
}
